<template>
  <div class="container-fluid mt--4">
    <div class="c--breadcrumb" :class="{ to_move: $sidebar.isMinimized }">
      <router-link to="/dashboard"><i class="el-icon-house"></i></router-link>
      <span><i class="el-icon-d-arrow-right mx-1 cb--divider"></i></span>
      <span>{{ $t("profile_page.profile") }}</span>
    </div>
    <div class="row">
      <div class="col">
        <user-card :user="user" :loading="loading" />
      </div>
    </div>
    <div class="row">
      <div class="col-xl-6 col-md-6 order-xl-1">
        <user-edit-card :user="user" :loading="loading" />
      </div>
      <div class="col-xl-6 col-md-6 order-xl-2">
        <user-edit-password-card :user="user" :loading="loading" />
      </div>
    </div>
  </div>
</template>

<script>
import UserEditCard from "@/views/Pages/UserProfile/UserEditCard.vue";
import UserEditPasswordCard from "@/views/Pages/UserProfile/UserEditPasswordCard.vue";
import UserCard from "@/views/Pages/UserProfile/UserCard.vue";
import axios from "axios";

export default {
  components: {
    UserEditCard,
    UserEditPasswordCard,
    UserCard,
  },
  data() {
    return {
      user: {},
      loading: false,
    };
  },
  methods: {
    async getData() {
      try {
        this.loading = true;
          if(!localStorage.getItem("testgold.userInfo")){
              await store.dispatch("userInfo")
            }
            const userInfo = JSON.parse(localStorage.getItem("testgold.userInfo"))
            if(userInfo){
              this.user = {
                ...userInfo,
                name: userInfo.full_name,
                tierName: userInfo.tier_name,
                tierLimits: userInfo.tier_limits,
                tierUsage: userInfo.tier_usage,
              };
            }else{
              console.log("navbar 402");
              localStorage.removeItem("vue-authenticate.access_token");
              localStorage.removeItem("testgold.aioToken");
              localStorage.setItem(
                "login--message",
                "User trial period has ended. Please contact support@testgold.dev."
              );
              window.location.reload();
            }
      } catch (e) {
        this.$notify({
          type: "danger",
          message: `An error has occured ${e.message}`,
        });
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    await this.getData();
  },
};
</script>

<style>
.b {
  border: 1px solid red;
}
</style>
